<template>
  <div>
    <div class="head_control">
      <div class="btn_box" @click="goBack">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="head_title">每日上传稿件</div>
    </div>
    <div class="content">
      <div class="imgbox">
        <img class="fileimg" src="../../assets/image/fileimg.png" alt="" />
      </div>
      <el-upload
        class="upload-demo upload_box"
        :action="uploadUrl"
        multiple
        :on-success="uploadSuccess"
      >
        <el-button class="el-upload__text upload_btn">
          上传文件
        </el-button>
      </el-upload>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { connectionrecord_zip, word_operate } from "@/utils/writer";
export default {
  data() {
    return {
      uploadUrl: this.$global.fileUploadUrl,
      type: "",
      information: {},
      fileUrl: "" //文件上传路径
    };
  },
  created() {
    // // 接受传递的参数
    // if (this.$route.query) {
    //   this.information = JSON.parse(this.$route.query.information)
    //   this.type = this.$route.query.sataus
    //   console.log(this.information, 111);
    // }

    this.writerId = JSON.parse(localStorage.getItem("userInfo")).id;
  },
  methods: {
    goBack() {
      this.$router.push({ path: "/UploadManuscript" });
    },
    //下载文件
    uploadSuccess(val) {
      var that = this;
      var file_url = val.data.url;
      // that.fileUrl = val.data.url;
      console.log(file_url);
      var suffix = file_url.substring(file_url.lastIndexOf(".") + 1);
      console.log(suffix);
      if (suffix == "zip") {
        // 上传压缩包
        let zip_obj = {
          departmentuser_id: that.writerId,
          file: file_url
        };
        connectionrecord_zip(zip_obj).then(res => {
          console.log(res);
          if (res.data.code == 0) {
            var fail_arr = [];
            fail_arr = res.data.msg;
            if (fail_arr.length > 0) {
              fail_arr.forEach(element => {
                that.$message({
                  showClose: true,
                  duration: 0,
                  type: "error",
                  message: element
                });
              });
            } else {
              that.$message({
                showClose: true,
                offset: 60,
                duration: 0,
                type: "error",
                message: item
              });
            }
          } else {
            var success_data = res.data.data.success;
            var success_msg = success_data.join(",");
            if (success_msg) {
              that.$message({
                offset: 60,
                type: "success",
                message: success_msg + ",上传成功！"
              });
            }
            this.$router.push({ path: "/UploadManuscript" });
          }
        });
      } else if (suffix == "docx" || suffix == "doc") {
        // 上传word文档
        let docx_obj = {
          departmentuser_id: that.writerId,
          file: file_url
        };
        word_operate(docx_obj).then(res => {
          if (res.data.code == 1) {
            that.$message.success(res.data.msg);
            this.$router.push({ path: "/UploadManuscript" });
          } else {
            console.log(res.data.msg);
            that.$message({
              showClose: true,
              duration: 0,
              type: "error",
              message: res.data.msg
            });
          }
        });
      } else {
        this.$message.error("文件格式不符合要求");
      }
    }
  }
};
</script>
<style scoped>
.head_control {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80px;
  margin-left: 15px;
}
.head_title {
  font-size: 20px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  margin-left: 30%;
}
.btn_box i {
  font-size: 25px;
}
.content {
  display: flex;
  flex-direction: column;
  height: 50vh;
  align-items: center;
  justify-content: space-between;
  margin-top: 25vh;
}
.imgbox {
  display: flex;
  justify-content: center;
  align-items: center;
}
.fileimg {
  width: 65%;
}
.upload_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload_box .upload_btn {
  width: 327px;
  height: 40px;
  background: #157df8;
  border-radius: 20px;
  color: #fff;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/view/writer/uploadFile.vue